import { EventEmitter } from '@angular/core';
import { FIRST_LAYER_ID, TIMELINE_CANVAS_LEVEL_STEP, TIMELINE_DEFAULT_WIDTH, TIMELINE_DEFAULT_ZOOM, TIMELINE_MAX_ZOOM, TIMELINE_MIN_ZOOM } from '../../constants';
import { Player } from '../entities/player';
import { RecorderStore } from '../stores/recorder.store';
var instance;
var TimelineStore = /** @class */ (function () {
    function TimelineStore(player, recorderStore) {
        var _this = this;
        this.player = player;
        this.recorderStore = recorderStore;
        this._currentPosition = 0;
        this._zoom = TIMELINE_DEFAULT_ZOOM;
        this._width = TIMELINE_DEFAULT_WIDTH;
        this.currentPositionChange = new EventEmitter();
        this.zoomChange = new EventEmitter();
        this.widthChange = new EventEmitter();
        this.change = new EventEmitter();
        this.selectedLayerId = FIRST_LAYER_ID;
        if (instance) {
            return instance;
        }
        else {
            instance = this;
        }
        recorderStore.onSampleFinish
            .subscribe(function (sampleData) { return _this.currentPosition = sampleData.endPosition; });
        recorderStore.onRecordChange
            .subscribe(function (recordData) { return _this.onRecordChange(recordData); });
        player.onPlaybackStart
            .subscribe(function (playbackConfig) { return _this.onPlaybackStart(playbackConfig); });
        player.onPlaybackStop
            .subscribe(function () { return _this.onPlaybackStop(); });
        player.onPlaybackFinish
            .subscribe(function (playbackConfig) { return _this.onPlaybackFinish(playbackConfig); });
    }
    TimelineStore.prototype.onRecordChange = function (recordData) {
        if (recordData.layerIds.indexOf(this.selectedLayerId) === -1) {
            this.selectLastLayer();
        }
    };
    TimelineStore.prototype.selectLastLayer = function () {
        this.selectedLayerId = this.recorderStore.lastLayerId;
    };
    TimelineStore.prototype.onPlaybackStart = function (playbackConfig) {
        this.currentPosition = playbackConfig.startPosition;
        this.playbackPreviousTime = Date.now();
        this.requestPlaybackAnimationFrame();
    };
    TimelineStore.prototype.playbackAnimate = function () {
        var currentTime = Date.now();
        this.currentPosition += currentTime - this.playbackPreviousTime;
        this.playbackPreviousTime = currentTime;
        this.requestPlaybackAnimationFrame();
    };
    TimelineStore.prototype.requestPlaybackAnimationFrame = function () {
        var _this = this;
        this.playbackRequestAnimationFrameId = requestAnimationFrame(function () { return _this.playbackAnimate(); });
    };
    TimelineStore.prototype.cancelPlaybackAnimationFrame = function () {
        cancelAnimationFrame(this.playbackRequestAnimationFrameId);
    };
    TimelineStore.prototype.onPlaybackStop = function () {
        this.cancelPlaybackAnimationFrame();
    };
    TimelineStore.prototype.onPlaybackFinish = function (playbackConfig) {
        this.cancelPlaybackAnimationFrame();
        this.currentPosition = playbackConfig.endPosition;
    };
    TimelineStore.prototype.isMaxZoom = function () {
        return this._zoom === TIMELINE_MAX_ZOOM;
    };
    TimelineStore.prototype.isMinZoom = function () {
        return this._zoom === TIMELINE_MIN_ZOOM;
    };
    Object.defineProperty(TimelineStore.prototype, "step", {
        get: function () {
            return this.convertPixelsToMilliseconds(TIMELINE_CANVAS_LEVEL_STEP);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TimelineStore.prototype, "currentPosition", {
        get: function () {
            return this._currentPosition;
        },
        set: function (value) {
            if (value < 0) {
                value = 0;
            }
            else {
                value = Math.round(value);
            }
            if (this._currentPosition !== value) {
                this._currentPosition = value;
                this.currentPositionChange.emit(value);
                this.change.emit();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TimelineStore.prototype, "recordingConfig", {
        get: function () {
            return {
                layerId: this.selectedLayerId,
                position: this.currentPosition,
                step: this.step,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TimelineStore.prototype, "zoom", {
        get: function () {
            return this._zoom;
        },
        set: function (value) {
            if (value > TIMELINE_MAX_ZOOM) {
                value = TIMELINE_MAX_ZOOM;
            }
            else if (value < TIMELINE_MIN_ZOOM) {
                value = TIMELINE_MIN_ZOOM;
            }
            this._zoom = value;
            this.zoomChange.emit(value);
            this.change.emit();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TimelineStore.prototype, "width", {
        get: function () {
            return this._width;
        },
        set: function (value) {
            this._width = value;
            this.widthChange.emit(value);
            this.change.emit();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TimelineStore.prototype, "currentPositionInPixels", {
        get: function () {
            return this.convertMillisecondsToPixels(this.currentPosition);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TimelineStore.prototype, "startVisiblePosition", {
        get: function () {
            return this.currentPosition - this.halfWidthInMilliseconds;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TimelineStore.prototype, "startVisiblePositionInPixels", {
        get: function () {
            return this.convertMillisecondsToPixels(this.startVisiblePosition);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TimelineStore.prototype, "endVisiblePosition", {
        get: function () {
            return this.currentPosition + this.halfWidthInMilliseconds;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TimelineStore.prototype, "widthInMilliseconds", {
        get: function () {
            return this.convertPixelsToMilliseconds(this.width);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TimelineStore.prototype, "halfWidthInMilliseconds", {
        get: function () {
            return this.convertPixelsToMilliseconds(this.halfWidth);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TimelineStore.prototype, "halfWidth", {
        get: function () {
            return this.width / 2;
        },
        enumerable: true,
        configurable: true
    });
    TimelineStore.prototype.convertPixelsToMilliseconds = function (pixels) {
        return pixels / this.zoom;
    };
    TimelineStore.prototype.convertMillisecondsToPixels = function (milliseconds) {
        return Math.round(milliseconds * this.zoom);
    };
    return TimelineStore;
}());
export { TimelineStore };



// WEBPACK FOOTER //
// ./src/app/rec/timeline/timeline.store.ts.pre-build-optimizer.js